import {createStore, combineReducers, compose} from 'redux';
import firebase from 'firebase';
import 'firebase/firestore';
import {reactReduxFirebase, firebaseReducer} from 'react-redux-firebase';
import {reduxFirestore, firestoreReducer} from 'redux-firestore';
// Reducers 
import notify_Reducer from './reducers/notify_Reducer';
import settingsReducer from './reducers/settings_Reducer';

const firebaseConfig = {
	apiKey: "AIzaSyDBNt5nSaO7xD5u7ALWm_XtyOssKJiZI8M",
  authDomain: "reactclientpanel-56fb5.firebaseapp.com",
  databaseURL: "https://reactclientpanel-56fb5.firebaseio.com",
  projectId: "reactclientpanel-56fb5",
  storageBucket: "reactclientpanel-56fb5.appspot.com",
  messagingSenderId: "178105284964"

};

// react-redux-firebase config
const rrfConfig = {
  userProfile: 'users',
  useFirestoreForProfile: true // Firestore for Profile instead of Realtime DB
}

// Initialize firebase instance
firebase.initializeApp(firebaseConfig);

// Initialize firestore 
//const firestore = firebase.firestore();
firebase.firestore();
//const settings = {timestampsInSnapshots: true};
//firestore.settings(settings);

// Add reactReduxFirebase enhancer when making store creator
const createStoreWithFirebase = compose(
  reactReduxFirebase(firebase, rrfConfig), // firebase instance as first argument
  reduxFirestore(firebase) // <- needed if using firestore
)(createStore)

// Add firebase and firestore to reducers
const rootReducer = combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer, // <- needed if using firestore
  notify: notify_Reducer,
  settings: settingsReducer
});

// Check for settings in localStorage
if(localStorage.getItem('settings') == null) {
  // Default settings
  const defaultSettings = {
    disableBalanceOnAdd: true,
    disableBalanceOnEdit: false,
    allowRegistration: false
  }

  // Set to localStorage
  localStorage.setItem('settings', JSON.stringify(defaultSettings));
}

// Create initial state
const initialState = { settings: JSON.parse(localStorage.getItem('settings')) };

// Create store
const store = createStoreWithFirebase(rootReducer, initialState, compose(
	reactReduxFirebase(firebase),
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
	));

export default store;